import { render } from "./CompanyNameView.vue?vue&type=template&id=07282e7a&scoped=true"
import script from "./CompanyNameView.vue?vue&type=script&lang=js"
export * from "./CompanyNameView.vue?vue&type=script&lang=js"

import "./CompanyNameView.vue?vue&type=style&index=0&id=07282e7a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07282e7a"]])

export default __exports__